import React from 'react';
import { makeStyles } from '@material-ui/styles';
import WarnningBox from './WarnningBox';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import StoreRoundedIcon from '@material-ui/icons/StoreRounded';
import {
  useState,
  } from 'react'
import { Typography } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({

  containerPage:{
    display: 'flex', 
    justifyContent: 'center', 
    width: "100vw", 
    height: "100vh",
    //backgroundColor: 'red',
  },

  containerFlex:{
  
    width: "100%",
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      top: "30vh",
      left: "30%",
      width: "40%",
      padding:  theme.spacing(2),
    },
   //backgroundColor: "red",
  },

  containerInfo:{
    display: 'flex',
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center',
    //backgroundColor: 'blue',
    width: "100%",
    padding: theme.spacing(2),
    marginTop: "10vh",
    fontSize: "1.3rem",
    textAlign: "center",
    color: theme.palette.text.secundary,
  },

  icon: {
    margin: theme.spacing(), 
    fontSize: "5rem",
    color: theme.palette.secondary.main,
  },

  image:{
    width:"150px", 
  }

}));


function parseFailure(failure,strings){
  let info={ title:strings.title_take_order, message: "Unknown"};

  if(failure.status === "notId"){
     info = {
      title:strings.title_take_order, 
      message: strings.message_take_order, 
      icon: 'shopping', 
     }
  }else  if(failure.status === "close"){
    info = {
      title:strings.title_take_order_close, 
      message:strings.message_take_order_close, 
      icon: 'store',
    };
  }else  if(failure.status === "disable"){
    const message = strings
    .formatString(strings.message_not_order_active,failure.fetchLocation.name); 
    info = {
       title:strings.title_take_order, 
       message:message, 
       icon: 'shopping',
    };

  }else  if(failure.status === "empty"){
    info = {
      title:failure.fetchLocation.name, 
      message: strings.message_not_content, 
      icon: 'store',
    }; 
  }else  if(failure.status === "error"){
    info = {
      title:"Error", 
      message:failure.code,  
      icon: 'info',
    }; 
  } 

  return info; 
}

export default function InfoPage(props) {
  const classes = useStyles();
  const {failure,strings} = props; 
  const [info] =  useState(parseFailure(failure,strings)); 

  //const urlImage = "https://res.cloudinary.com/wikimenu/image/upload/v1620754385/store-app/chekout_zyd1l3.png"; 
  //console.debug("InfoPage"); 

  return (
    <div className = {classes.containerPage}>  
       {
       <div className = {classes.containerFlex}>
        <div className = {classes.containerInfo}>
            {/* <img className ={classes.image} src={urlImage} alt={"checkout"}  /> */}

            { info.icon === "shopping" && <ShoppingBasketIcon className ={classes.icon} color='accent'/>}
            { info.icon === "info" &&  <ErrorOutlineIcon className ={classes.icon}/>}
            { info.icon === "store" && <StoreRoundedIcon className ={classes.icon}/>}
            {<Typography variant="h6" color="textPrimary">{info.title.toUpperCase()}</Typography>}
            
            <WarnningBox
                message={info.message}    
                icon={false}   
            />
        </div>
             
        </div>
        }
    </div>
  );
}